import R from 'app/assets/R'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IFormRule } from './type'
import { IPropsCreateWarehouse, StatusWarehouseType } from '.'
import { notificationController } from 'app/controllers/notification-controller'
import { IWarehouse } from 'app/api/inventory-new/model/management'
import { requestCreateWarehouseManagement } from 'app/api/inventory-new'
import { get } from 'lodash'

export const useModalHook = ({ fetchTable }: IPropsCreateWarehouse) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm()
  const [visible, setVisible] = useState(false)
  const [status, setStatus] = useState<StatusWarehouseType | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
    form.resetFields()
  }

  const handleSubmit = async (values: IWarehouse) => {
    setIsLoading(true)

    try {
      await requestCreateWarehouseManagement(values)

      setIsLoading(false)
      handleCancel()
      fetchTable?.()

      notificationController.success({
        message: t(R.strings.provider_add),
        description: t(R.strings.success),
      })

      // eslint-disable-next-line
    } catch (error) {
      notificationController.error({
        message: t(R.strings.provider_add),
        description: get(error, 'message', ''),
      })
      setIsLoading(false)
    }
  }

  const rules: IFormRule = useMemo(() => {
    return {
      name: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.warehouse_name),
          }),
        },
      ],
      code: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.warehouse_code),
          }),
        },
      ],
      roadWarehouseCode: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.warehouse_road_code),
          }),
        },
      ],
      unitId: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.branch),
          }),
        },
      ],
      status: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.status),
          }),
        },
      ],
    }
  }, [t])

  return {
    form,
    visible,
    t,
    showModal,
    handleSubmit,
    handleCancel,
    rules,
    setStatus,
    status,
    isLoading,
  }
}
